var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useState } from "react";
import { QuiButton } from "../../QuiButton/QuiButton.js";
import { QuiIcon } from "../../_primitives/QuiIcon/QuiIcon.js";
import { QuiTextInput } from "../../QuiTextInput/QuiTextInput.js";
import { QuiField } from "../QuiField.js";
import { useQuiField } from "../useQuiField.js";
const QuiShowPasswordToggle = ({ type, toggleType }) => {
    const onClick = useCallback((e) => {
        toggleType(type);
        e.preventDefault();
        e.stopPropagation();
        return false;
    }, [toggleType, type]);
    return (React.createElement(QuiButton, { onClick: onClick, size: "sm", className: "fix-right", variant: "minimal", tabIndex: -1, type: "button", style: { margin: "-0.5rem" } },
        React.createElement(QuiIcon, { icon: type === "text" ? "eye" : "eye-off", size: "sm" })));
};
// TValue represents the underlying data-type. If different from string, you can provide format and parse props to convert to and from the input element
/** Controlled text field component that manages field state within a form */
export function QuiPasswordField(_a) {
    var { name, disabled, label, helperText, subHelperText, size, iconLeft, placeholder, validate, config, autoComplete, hideShowPasswordToggle } = _a, otherProps = __rest(_a, ["name", "disabled", "label", "helperText", "subHelperText", "size", "iconLeft", "placeholder", "validate", "config", "autoComplete", "hideShowPasswordToggle"]);
    const { inputProps, fieldProps } = useQuiField(name, Object.assign(Object.assign({}, config), { validate }));
    const [type, setType] = useState("password");
    const toggleShowPassword = useCallback((type) => {
        setType(type === "text" ? "password" : "text");
    }, []);
    return (React.createElement(QuiField, Object.assign({ label: label, helperText: helperText, subHelperText: subHelperText, disabled: disabled }, fieldProps, otherProps),
        React.createElement(QuiTextInput, Object.assign({ type: type, placeholder: placeholder, size: size, iconLeft: iconLeft, iconRight: !hideShowPasswordToggle && !disabled && React.createElement(QuiShowPasswordToggle, { type: type, toggleType: toggleShowPassword }), disabled: disabled, autoComplete: autoComplete, "data-lpignore": autoComplete === "off" }, inputProps))));
}
